/* eslint-disable import/prefer-default-export, import/no-named-as-default */
import React from 'react';
import { useQuery } from '@tanstack/react-query';
import QueryKeys from '../config';
import Requests from '../../../network/accounts';

const useVendors = (props?: { enabled?: boolean }) => {
  const { enabled } = props || { enabled: false };
  const reqObj = {
    status: 'ACTIVE',
  };
  const {
    isLoading, data, error, refetch,
  } = useQuery({
    queryKey: QueryKeys.VENDORS,
    queryFn: async () => Requests.getInstance().getConsultancyOptions(reqObj).then(
      (response) => response.consultancies,
    ),
    refetchOnWindowFocus: false,
    initialData: [],
    enabled,
  });

  const vendorOptions = React.useMemo(
    () => data?.map((option) => ({ label: option.name, value: option.id })) || [],
    [data],
  );

  return {
    vendorsLoading: isLoading,
    vendorOptions,
    data,
    error,
    fetchVendors: refetch,
  };
};

export {
  useVendors,
};
